/**
 * PDP v2 set row "See all" (019 §8.3; Mat, 2026-09-30). Loaded by the set row,
 * after pdp-v2.js (theme.pdpV2: isInjected, track, nearTop). Every use of the
 * link sends set_see_all once (a native middle-click arrives as auxclick, not
 * click; right-clicks are not a use). An ordinary click opens the offer section's
 * "Complete the outfit" tab in place when that tab is the same category (its
 * panel's data-tag); anything else follows the href (the offer collection by
 * category), as do modified clicks and injected copies.
 *
 * collection-offer.js starts the section lazily near the viewport (selecting
 * its first tab) and moves off a tab whose panel loads empty, whatever the
 * shopper chose meanwhile. So the outfit tab is held, with no timeout treated
 * as readiness (048-F1): re-selected whenever the section moves off it, until
 * the section has started and nothing is loading. Holding stops when the
 * outfit tab is hidden (it loaded empty: the section's move is right), when
 * the shopper works the tabs, on detachment, on a newer See-all, or after 30
 * s without settling (then nothing more is done).
 *
 * Focus moves to the tab. After a tap or mouse click it shows no ring (Mat's
 * UAT, 2026-09-30: WebKit draws :focus-visible for script focus after a tap);
 * a keyboard press keeps it, and any key or leaving the tab restores it.
 */
(function () {
  'use strict';

  var theme = window.theme = window.theme || {};
  if (theme.pdpV2SeeAll) return;
  var S = theme.pdpV2SeeAll = {};
  var api = function () { return theme.pdpV2 || {}; };

  var holding = null;

  /** Hold tab (in section) until the section settles on it; returns the stop function. */
  S.hold = function (section, tab) {
    if (holding) holding();
    var done = false;
    var observer = new MutationObserver(check);
    var timer = setTimeout(stop, 30000);
    function onShopper(evt) {
      if (evt.isTrusted && evt.target && evt.target.closest && evt.target.closest('[role="tablist"]')) stop();
    }
    function stop() {
      if (done) return;
      done = true;
      observer.disconnect();
      clearTimeout(timer);
      section.removeEventListener('pointerdown', onShopper, true);
      section.removeEventListener('keydown', onShopper, true);
      if (holding === stop) holding = null;
    }
    function check() {
      if (done) return;
      if (!tab.isConnected || tab.hidden) { stop(); return; }
      if (!section.querySelector('[data-offer-tab][aria-selected="true"]')) return; // not started yet
      if (tab.getAttribute('aria-selected') !== 'true') { tab.click(); return; }
      if (!section.querySelector('[data-offer-panel][data-loading]')) stop();
    }
    holding = stop;
    section.addEventListener('pointerdown', onShopper, true);
    section.addEventListener('keydown', onShopper, true);
    observer.observe(section, { subtree: true, attributes: true, attributeFilter: ['aria-selected', 'data-loading', 'hidden'] });
    check();
    return stop;
  };

  /** Mark tab so its focus ring is hidden until a key is pressed on it or it loses focus. */
  S.quietFocus = function (tab) {
    if (tab.hasAttribute('data-pdp-v2-quiet-focus')) return;
    tab.setAttribute('data-pdp-v2-quiet-focus', '');
    function clear(evt) {
      // The window losing focus blurs the tab but leaves it the active element.
      if (evt.type === 'blur' && document.activeElement === tab) return;
      tab.removeAttribute('data-pdp-v2-quiet-focus');
      tab.removeEventListener('blur', clear);
      tab.removeEventListener('keydown', clear);
    }
    tab.addEventListener('blur', clear);
    tab.addEventListener('keydown', clear);
  };

  /** The full-page See-all link an event hit, counted once; null otherwise. */
  function used(evt) {
    var link = evt.target && evt.target.closest ? evt.target.closest('[data-pdp-v2-see-all]') : null;
    var a = api();
    if (!link || (a.isInjected && a.isInjected(link))) return null;
    if (a.track) a.track('set_see_all', { label: link.textContent.replace('→', '').trim() });
    return link;
  }

  // A native middle-click fires auxclick, not click (050-F1): count it and
  // leave the link to open. Right-clicks (button 2) are not a use.
  document.addEventListener('auxclick', function (evt) {
    if (evt.button === 1) used(evt);
  });

  document.addEventListener('click', function (evt) {
    if (evt.button) return; // non-primary buttons are auxclick's
    var link = used(evt);
    if (!link) return;
    // Modified or already-handled clicks keep the link (a new tab or window).
    if (evt.defaultPrevented || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
    var a = api();
    var tag = link.getAttribute('data-pdp-v2-see-all');
    var panel = tag && document.querySelector('collection-offer-products [data-offer-panel="outfit"][data-tag="' + tag + '"]');
    var section = panel && panel.closest('collection-offer-products');
    var tab = section && section.querySelector('[data-offer-tab="outfit"]:not([hidden])');
    if (!tab) return;
    evt.preventDefault();
    if (a.nearTop) a.nearTop(tab);
    if (evt.detail) S.quietFocus(tab); // a tap or click; a keyboard press has detail 0
    tab.focus({ preventScroll: true });
    S.hold(section, tab);
  });
})();
